import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalWindowComponent } from './modal-window.component';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  declarations: [ModalWindowComponent],
  imports: [
    CommonModule,
    BrowserModule
  ],
  exports: [
    ModalWindowComponent,
  ]
})
export class ModalWindowModule { }
